import { useField } from 'formik';
import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { FormikDatepickerProps } from '.';
import { Label } from '../Label';
import StyledKeyboardDatePicker from '../StyledKeyboardDatePicker';

const FormikKeyboardDatePicker: React.FunctionComponent<FormikDatepickerProps> = ({
  formikKey,
  labelContent,
  showLabel = true,
  formControlProps,
  ...props
}) => {
  const [field, meta, helpers] = useField({ name: formikKey, type: 'text' });
  const isInputError = meta.touched && Boolean(meta.error);
  return (
    <FormControl error={isInputError} {...formControlProps}>
      {showLabel && <Label>{labelContent}</Label>}
      <StyledKeyboardDatePicker
        {...props}
        value={field.value}
        onChange={(date) => {
          helpers.setValue(date);
        }}
        error={isInputError}
      />
      {meta.touched && meta.error && (
        <Box py={1}>
          <Typography color="error">{meta.error}</Typography>
        </Box>
      )}
    </FormControl>
  );
};

export { FormikKeyboardDatePicker };
